<template>
  <div class="tableView" v-loading="loading">
    <div class="tv_header">
      <div class="tv_h_left">
        <span :class="{ tagActive: tagIndex == 0 }" @click="changeTagIndex(0)"
          >按表单查看</span
        >
        <span :class="{ tagActive: tagIndex == 1 }" @click="changeTagIndex(1)"
          >按人员查看</span
        >
      </div>
      <div class="tv_h_right">
        <el-input
          placeholder="请输入内容"
          style="width: 300px;margin-right: 30px;"
          @keyup.enter.native="getData()"
          v-model="searchValue"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getData()"
          ></el-button>
        </el-input>

        <el-button type="primary" @click="addForm()">创建表单</el-button>

        <!-- <el-button type="primary">数据导入</el-button> -->
      </div>
    </div>
    <div class="tv_bottom" v-loading="tableLoading">
      <el-table
        v-if="tagIndex == 0 && !tableLoading"
        :data="showTableData"
        border
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          width="80"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column prop="title" width="400" label="表单名称">
        </el-table-column>
        <el-table-column prop="typeN" width="200" :filters="typeFilterList" :filter-method="typeFilterFn" label="所属栏目">
        </el-table-column>
        <el-table-column
          prop="uname"
          width="150"
          label="创建人"
        >
        <template slot="header" slot-scope="scope">
          <div class="creator_column">
            <el-dropdown trigger="click" @command="creatorFilterFn">
              <span class="creator_column_span">
                创建人<i class="el-icon-caret-bottom el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in creatorFilterList" :key="item.value" :command="item.value">{{ item.text }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </template>
      </el-table-column>
        <el-table-column prop="look" width="150" label="表单状态" :filters="statusFilterList" :filter-method="statusFilterFn">
          <template slot-scope="scope">
            <span>{{ getLook(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="worksCount"
          width="150"
          sortable
          label="提交数量"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" min-width="300">
          <template slot-scope="scope">
           <div class="tableBtnArea">
            <el-tooltip
              class="item"
              effect="light"
              content="编辑"
              placement="top"
              v-if="
                scope.row.userid == userId ||
                  (scope.row.course_teacher &&
                    scope.row.course_teacher.indexOf(userId) !== -1) ||
                  role == '1'
              "
            >
              <img
                 @click="editForm(scope.row)"
                src="../../../../assets/icon/test/edit_test_icon.png"
                alt=""
              />
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="light"
              content="查看"
              placement="top"
            >
              <img
               @click="checkForm(scope.row.courseId)"
                src="../../../../assets/icon/test/check_test_icon.png"
                alt=""
              />
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="light"
              content="复制"
              placement="top"
            >
              <img  @click="copyForm(scope.row.courseId)" src="../../../../assets/icon/test/paste-icon.png" alt="" />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="提醒"
              placement="top"
              v-if="
                scope.row.userid == userId ||
                  (scope.row.course_teacher &&
                    scope.row.course_teacher.indexOf(userId) !== -1) ||
                  role == '1'
              "
            >
              <img
               @click="warnForm(scope.row)"
                src="../../../../assets/icon/test/share_test_icon.png"
                alt=""
              />
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="light"
              content="删除"
              placement="top"
              v-if="
                scope.row.userid == userId ||
                  (scope.row.course_teacher &&
                    scope.row.course_teacher.indexOf(userId) !== -1) ||
                  role == '1'
              "
            >
              <img
               @click="deleteForm(scope.row.courseId)"
                src="../../../../assets/icon/test/delete_test_icon.png"
                alt=""
              />
            </el-tooltip>
           </div>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-if="tagIndex == 1 && !tableLoading"
        :data="showTableData"
        border
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          width="80"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column prop="name" width="200" label="姓名"></el-table-column>
        <el-table-column
          prop="className"
          width="200"
          label="学科"
        ></el-table-column>
        <el-table-column
          v-for="item in teaType"
          :key="item.id"
          :label="item.name"
          width="200"
          align="left"
          :filters="getNameTTypeFiler(item)"
          :filter-method="
            getNameTTypeFiler(item)
              ? (value, row) => {
                  return filterTType(value, row, index);
                }
              : null
          "
        >
          <template slot-scope="scope">
            {{ getTType(item.id, scope.row.cclassid) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="worksCount"
          width="200"
          label="已提交数量"
          sortable
        ></el-table-column>
        <el-table-column
          prop="testCount"
          width="200"
          label="已完成表单"
          sortable
        ></el-table-column>

        <el-table-column fixed="right" label="操作" min-width="100">
          <template slot-scope="scope">
            <div class="tableBtnArea"> <el-tooltip
              class="item"
              effect="light"
              content="查看"
              placement="top"
            >
              <img
                @click="checkPerson(scope.row.userid)"
                src="../../../../assets/icon/test/check_test_icon.png"
                alt=""
              />
            </el-tooltip></div>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <warnDialog ref="warnDialogRef" />
  </div>
</template>

<script>
import warnDialog from "../dialog/warnDialog.vue";
export default {
  props: {
    typeId: {
      type: String,
      default: ""
    },
    typeList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    warnDialog
  },
  data() {
    return {
      tableData: [],
      tagIndex: 0,
      displayRange: 0, //4：所有人  2：他人  0：我的
      searchValue: "",
      showTableData: [],
      userId: this.$route.query.userid,
      oid: this.$route.query.oid,
      org: this.$route.query.org,
      role: this.$route.query.role,
      tableLoading: false,
      teaType: [],
      loading: false,
      creatorFilterList:[{
        text:"我的",
        value:0,
      },{
        text:"所有人",
        value:4
      }],
      statusFilterList:[{
        text:"未发布",
        value:"未发布"
      },{
        text:"逾期",
        value:"逾期"
      },{
        text:"进行中",
        value:"进行中"
      },{
        text:"未进行",
        value:"未进行"
      },{
        text:"已完成",
        value:"已完成"
      }],
    };
  },
  computed: {
    typeString() {
      let _result = "";
      _result = this.typeList.map(i => i.id);
      _result.push(this.typeId);
      _result = _result.join(",");
      return _result;
    },
    getLook() {
      return function(item) {
        let content = "";
        if (item.look == "1" || item.look == "") {
          content = "未发布";
        }
        let now = new Date().getTime();
        let isTime = item.over_at && new Date(item.over_at).getTime();
        if (
          item.over_at &&
          item.look == "2" &&
          now > isTime &&
          ((item.isUserCount > 0 && item.isUserCount > item.worksPerson) ||
            item.isUserCount == 0)
        ) {
          content = "逾期";
        }

        if (
          ((item.over_at && item.look == "2" && isTime > now) ||
            (!item.over_at && item.look == "2")) &&
          ((item.isUserCount == 0 && item.worksPerson > 0) ||
            (item.isUserCount > 0 &&
              0 < item.worksPerson &&
              item.worksPerson < item.isUserCount))
        ) {
          content = "进行中";
        }

        if (
          ((item.over_at && item.look == "2" && isTime > now) ||
            (!item.over_at && item.look == "2")) &&
          item.worksPerson == 0
        ) {
          content = "未进行";
        }

        if (
          item.look == "2" &&
          item.isUserCount > 0 &&
          item.isUserCount <= item.worksPerson
        ) {
          content = "已完成";
        }
        return content;
      };
    },
    getTType() {
      return function(pid, cclassid) {
        if (cclassid) {
          let string = [];
          this.teaType.forEach(e => {
            if (e.id == pid) {
              for (var i = 0; i < e.child.length; i++) {
                if (cclassid.includes(e.child[i].id)) {
                  string.push(e.child[i].name);
                }
              }
            }
          });
          return string.length ? string.join(",") : "-";
        } else {
          return "-";
        }
      };
    },
    getNameTTypeFiler() {
      return item => {
        return item.child.length
          ? item.child.map(child => ({
              text: child.name,
              value: child.id
            }))
          : null;
      };
    },
    typeFilterList(){
      let _result = [];

      if(this.typeList.length){
        _result = this.typeList.map(i=>{
          let _list = [];
          if(i.pidList){
            _list = i.pidList.split(",")
          }
          _list.push(i.id);

          return {
            text:i.name,
            value:_list.join(',')
          }
        })
      }

      return _result;

    }
  },
  watch: {
    typeId() {
      this.getData();
    }
  },
  methods: {
    getData() {
      this.tableData = [];
      this.showTableData = [];
      if (this.tagIndex == 0) {
        this.getFormData();
      } else if (this.tagIndex == 1) {
        this.getPersonData();
      }
    },
    getFormData() {
      const cardType = this.tagIndex;
      let params = {
        uid: this.userId,
        type: this.displayRange,
        oid: this.oid,
        org: this.org,
        typeId: this.typeString,
        textValue: this.searchValue
      };
      // 4：所有人
      // 2：他人
      // 0：我的
      this.tableLoading = true;
      this.ajax
        .get(this.$store.state.api + "selectTesttCourse_sass", params)
        .then(res => {
          if(cardType!=this.tagIndex)return;
          let _data = res.data[0];
          if (_data.length > 0) {
            this.tableData = _data;
            this.showTableData = this.tableData;
          }
          this.tableLoading = false;
          this.$forceUpdate();
        })
        .catch(e => {
          console.log(e);
          this.tableLoading = false;
        });
    },
    getPersonData() {
      const cardType = this.tagIndex;
      let params = {
        oid: this.oid,
        org: this.org,
        typeId: this.typeString,
        textValue: this.searchValue
      };
      this.tableLoading = true;
      this.ajax
        .get(this.$store.state.api + "selectTesttCourse2_sass", params)
        .then(res => {
          if(cardType!=this.tagIndex)return;
          let _data = res.data[0];
          let _teaType = res.data[1];
          let _teaType2 = res.data[2];
          if (_data.length > 0) {
            this.tableData = _data;
            this.showTableData = this.tableData;
          }

          if (_teaType.length > 0) {
            this.teaType = _teaType;
            this.teaType.forEach(e => {
              e.child = [];
              e.value = [];
              _teaType2.forEach(i => {
                if (e.id == i.parentid) {
                  e.child.push({ id: i.id, name: i.name });
                }
              });
            });
          }
          this.tableLoading = false;
          this.$forceUpdate();
        })
        .catch(e => {
          console.log(e);
          this.tableLoading = false;
        });
    },
    changeTagIndex(newTag) {
      this.tagIndex = newTag;
      this.searchValue = "";
      this.getData();
    },
    filterTType(value, row, index) {
      return row.cclassid && row.cclassid.indexOf(value) != -1;
    },
    typeFilterFn(value,row){
      return row.typeid && value.indexOf(row.typeid)!=-1;
    },
    statusFilterFn(value,row){
      return this.getLook(row) == value;
    },
    creatorFilterFn(value){
      this.displayRange = value;
      this.getData();
    },
    checkPerson(uid) {
      this.$router.push(
        "/checkToTest2?uid=" +
          uid +
          "&userid=" +
          this.userId +
          "&oid=" +
          this.oid +
          "&org=" +
          this.org +
          "&type=2" +
          "&role=" +
          this.role +
          "&back=sass"
      );
    },
    editForm(item) {
      if (item.worksCount > 0) {
        this.$confirm(
          "该表单已存在数据，如果修改题目可能会清空已提交数据，是否重新编辑？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.$router.push(
              "/addTest?cid=" +
                item.courseId +
                "&userid=" +
                this.userId +
                "&oid=" +
                this.oid +
                "&org=" +
                this.org +
                "&type=2" +
                "&role=" +
                this.role +
                "&back=sass"
            );
          })
          .catch(() => {
            return;
          });
      } else {
        this.$router.push(
          "/addTest?cid=" +
            item.courseId +
            "&userid=" +
            this.userId +
            "&oid=" +
            this.oid +
            "&org=" +
            this.org +
            "&type=2" +
            "&role=" +
            this.role +
            "&back=sass"
        );
      }
    },
    checkForm(courseId) {
      this.$router.push(
        "/checkToTest?cid=" +
          courseId +
          "&userid=" +
          this.userId +
          "&oid=" +
          this.oid +
          "&org=" +
          this.org +
          "&type=2" +
          "&role=" +
          this.role +
          "&back=sass"
      );
    },
    copyForm(courseId) {
      let params = [
        {
          cid: courseId,
          uid: this.userId
        }
      ];
      this.ajax
        .post(this.$store.state.api + "copyTest", params)
        .then(res => {
          this.displayRange = "0";
          this.$message.success("复制成功");
          this.getData();
        })
        .catch(err => {
          console.error(err);
        });
    },
    deleteForm(courseId) {
      this.$confirm("确定删除此表单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          let params = [
            {
              cid: courseId
            }
          ];
          this.ajax
            .post(this.$store.state.api + "deleteTestCourse", params)
            .then(res => {
              this.loading = false;
              this.$message.success("删除成功");
              this.getData();
            })
            .catch(err => {
              loading.close();
              this.loading = false;
              console.error(err);
            });
        })
        .catch(() => {
          return;
        });
    },
    warnForm(data) {
      this.$refs.warnDialogRef.open({ testJson: data });
    },
    addForm() {
      this.$router.push(
        "/addTest?userid=" +
          this.userId +
          "&oid=" +
          this.oid +
          "&org=" +
          this.org +
          "&role=" +
          this.role +
          "&typeId1=" +
          this.typeId +
          "&back=sass"
      );
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.tableView {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

.tv_header {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}

.tv_h_left > span {
  margin-right: 30px;
  cursor: pointer;
  transition: 0.3s;
  position: relative;
}

.tv_h_left > span:hover {
  color: #1684fc;
}

.tagActive {
  color: #1684fc;
}

.tagActive::after {
  content: "";
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: -5px;
  left: 0;
  background-color: #1684fc;
}

.tv_h_right {
  width: auto;
  height: auto;
  display: flex;
}

.tv_bottom {
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.tableBtnArea{
  width: auto;
  display: flex;
}

.tableBtnArea>img{
  width: 18px;
  height: 18px;
  margin-right: 25px;
  cursor: pointer;
}

.creator_column_span{
  cursor: pointer;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/sassPlatform/view/tableView.vue